import { render, staticRenderFns } from "./workspace-column.vue?vue&type=template&id=e36599ec"
import script from "./workspace-column.vue?vue&type=script&lang=js"
export * from "./workspace-column.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports